const ACTIVATION_ID_PATTERN = /^[1-9][0-9]*-[1-9][0-9]*$/
const ACCEPTED_KINDS = new Set([ "tab-return", "foreground" ])

export function lifecycleActivation(event, acceptedIntentId) {
  const kind = event.detail?.kind
  if (!ACCEPTED_KINDS.has(kind)) return null

  const id = event.detail?.id
  const acknowledge = event.detail?.acknowledge
  if (id == null && acknowledge == null) {
    return { kind, id: null, duplicate: false, acknowledge: null }
  }
  if (!ACTIVATION_ID_PATTERN.test(id) || typeof acknowledge !== "function") return null

  return { kind, id, duplicate: id === acceptedIntentId, acknowledge }
}

export function acknowledgeLifecycleActivation(controller, activation) {
  if (!activation.id) return

  controller.acceptedLifecycleIntentId = activation.id
  activation.acknowledge()
}
